import type { AxiosInstance } from 'axios'

const CSRF_COOKIE_NAME = 'csrfToken='

export function readCsrfToken(): string | undefined {
    return document.cookie
        .split('; ')
        .find((row) => row.startsWith(CSRF_COOKIE_NAME))
        ?.slice(CSRF_COOKIE_NAME.length)
}

export function attachCsrfInterceptor(client: AxiosInstance): void {
    client.interceptors.request.use((config) => {
        const csrfToken = readCsrfToken()
        if (csrfToken) config.headers.set('x-csrf-token', csrfToken)
        return config
    })
}
